/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.searchModule')
.directive('bulbSearchForm', ['$timeout', bulbSearchForm]);

function bulbSearchForm($timeout) {
  return {
    restrict: 'E',
    scope: true,
    controller: 'SearchFormController as searchFormCtrl',
    templateUrl: 'ajs/search/searchform.html',
    link: function(scope, elem, attrs) {
      var jqInput = jQuery('#query');
      function checkVisible() {
        if (jqInput.is(':visible')) {
          jqInput.focus();
        } else {
          $timeout(checkVisible, 100);
        }
      }
      scope.$watch('headerCtrl.headerType === "search"', function(isSearchActive) {
        if (isSearchActive) {
          // Cannot focus the search input until it is visible.
          // The animation fading in the header contents takes the default duration, 400 ms.
          // Test first after 500ms, thereafter, every 100ms.
          // DO LATER : Instead, there ought to be a way to add a function to the "done" on the animation.
          $timeout(checkVisible, 500);
        }
      });
    }
  };
}
